import { render, staticRenderFns } from "./UsageCard.vue?vue&type=template&id=fa81e0dc&scoped=true"
import script from "./UsageCard.vue?vue&type=script&lang=js"
export * from "./UsageCard.vue?vue&type=script&lang=js"
import style0 from "./ServerManage.scss?vue&type=style&index=0&id=fa81e0dc&prod&lang=scss&scoped=true&external"
import style1 from "./UsageCard.vue?vue&type=style&index=1&id=fa81e0dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa81e0dc",
  null
  
)

export default component.exports